var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.classObj },
    [
      _c(
        "v-card",
        {
          staticClass: "card__wrap",
          attrs: { to: _vm.to },
          on: { click: _vm.clickHandler },
        },
        [
          _c(
            "header",
            { staticClass: "card__header pa-4" },
            [
              _c("h2", { staticClass: "card__title" }, [
                _vm._v(_vm._s(_vm.data.asiakas.nimi)),
              ]),
              _c("v-tooltip", {
                attrs: { top: "" },
                scopedSlots: _vm._u([
                  {
                    key: "activator",
                    fn: function (ref) {
                      var on = ref.on
                      return [
                        _c("StatusIcon", {
                          staticClass: "card__icon",
                          attrs: {
                            size: "large",
                            icon: _vm.data.ikoni_ja_vari.ikoni,
                            hoverIcon: "open-in-new",
                            bgColor: _vm.data.ikoni_ja_vari.vari,
                            eventListener: on,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$router.push({
                                name: "laskutus-nayta",
                                params: { id: _vm.data.id },
                              })
                            },
                          },
                        }),
                      ]
                    },
                  },
                  {
                    key: "default",
                    fn: function () {
                      return [_c("span", [_vm._v("Avaa lasku")])]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "v-card-text",
            { staticClass: "card__content" },
            [
              _c(
                "v-row",
                { staticClass: "card__details" },
                [
                  _c("v-col", { attrs: { cols: "6" } }, [
                    _c("span", { staticClass: "grey--text" }, [
                      _vm._v("Laskunumero"),
                    ]),
                    _c("br"),
                    _c("span", [_vm._v(_vm._s(_vm.data.nro))]),
                  ]),
                  _c(
                    "v-col",
                    { staticClass: "text-right", attrs: { cols: "6" } },
                    [
                      _c("span", { staticClass: "grey--text" }, [
                        _vm._v(_vm._s(_vm.data.paamiesTitle)),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "my-2" }),
              _c(
                "v-row",
                { staticClass: "card__details" },
                [
                  _c("v-col", { attrs: { cols: "8" } }, [
                    _c("span", { staticClass: "grey--text" }, [
                      _vm._v("Päämies"),
                    ]),
                    _c("br"),
                    _vm.data.paamies
                      ? _c("span", [_vm._v(_vm._s(_vm.data.paamies.nimi))])
                      : _vm._e(),
                  ]),
                  _c("v-col", { attrs: { cols: "4" } }),
                  _c(
                    "v-col",
                    {
                      staticClass: "text-right align-self-end",
                      attrs: { cols: "12" },
                    },
                    [
                      _c("span", { staticClass: "grey--text" }, [
                        _vm._v("Avoinna"),
                      ]),
                      _c("br"),
                      _c("span", { staticClass: "orange--text subtitle-1" }, [
                        _vm._v(
                          _vm._s(_vm._f("formatSumToFixed2")(_vm.data.avoinna))
                        ),
                      ]),
                      _c("br"),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.data.stacked
        ? [
            _c("v-card", { staticClass: "card__stackItem" }),
            _c("v-card", {
              staticClass: "card__stackItem card__stackItem--second",
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }